import { render, staticRenderFns } from "./ServerTable.vue?vue&type=template&id=43146b0b&scoped=true"
import script from "./ServerTable.vue?vue&type=script&lang=js"
export * from "./ServerTable.vue?vue&type=script&lang=js"
import style0 from "./ServerTable.vue?vue&type=style&index=0&id=43146b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43146b0b",
  null
  
)

export default component.exports